export const name = "Race and Privilege: An Overdue Conversation"
export const menu = "Race & Privilege"
export const edition = "Race & Privilege Edition"
export const suggestedPlayer = "2+ players"
export const color = {
    primary: {
        main:  '#181818',
        contrastText: '#ffffff',
    },
    secondary: {
        main:  '#181818',
    }
}
export const levels = ['Level 1 Perception', 'Level 2 Connection', 'Level 3 Reflection']
export const isExpansion = false

export const backDesc = [
    "If a conversation\n is hard, it's probably\n the one worth having."
]

export const instruction = [
    "This conversation isn't easy.",
    "Remember, not everyone will be on the same level of understanding as you, and that's okay.",
    "This conversation doesn't end after one sitting, or after a wave of outrage online. It is a lifelong conversation that starts with ourselves.",
    "Ready?",
]

export const howToPlay = [
    "Find a parner with an open heart and mind. This person can have completely different or very similar viewpoints. Alternate asking and answering each question with your partner(s).",
    "Remember, the more you have in your toolkit the better you can be at sharing your views with someone else. We've provided resources throughout this PDF to help fill that toolkit. Review definitions together before beginning the game.",
]

export const level1 = [
    "What privileges\n do you think I have?\n Explain.",
    "What stereotypes\n do you think have been made\n about you, if any?",
    "Wild Card Write down your\n biggest fear entering this\n conversation about race.\n 1 minute. Compare.",
]

export const level2 = [
    "In your day to day life,\n how often do you think about\n race / the color of your own skin?\n Why do you think that is?",
    "What qualities\n do you associate with\n a good listener?",
    "Has your family ever\n said something you deeply\n disagreed with regarding the\n topic of race / racism? How\n did you respond?",
    "How do you feel about\n cancel culture in regards\n to race / racism? What role\n does it play? How does it\n help? How does it hurt?",
    "On a scale of 1-10 how would\n you rate your current knowledge\n of our nation's history regarding\n slavery and systemic racism? What\n can you do to help raise your\n knowledge by 1 point?",
    "When was the last time\n you had a shift in perspective\n regarding the topic of race /\n racism? How did that shift\n occur for you?",
    "What's an unpopular opinion\n you hold regarding race / racism\n that you feel too afraid to voice?\n Have you ever challenged\n that opinion?",
    "What did the people\n that raised you teach\n you about race? Directly\n or indirectly?",
    "Permission to sound\n uninformed: What have you\n always wondered but felt\n too afraid to ask about\n race / racism?",
    "Have you ever experienced\n racism in your friend / peer\n group? Did you call it out?\n Why or why not?",
    "What was your first\n memory realizing that\n race existed?",
    "Have you ever had to unfriend\n or create a boundary towards\n someone you love because of\n a disconnect concerning the\n topic of race / racism?",
    "What did you grow up\n believing \"beautiful\" looked\n like? Where did that come from?\n How has it evolved?",
    "What do you feel when you\n hear \"Black lives matter\"?\n \"All lives matter\"?",
    "What has been your personal\n experience with police? Why do\n you think that is? When you get\n pulled over how safe\n do you feel?",
    "Have you ever been called out\n for saying something insensitive\n regarding race? How did it make\n you feel? Did it change you?\n Why or why not?",
    "How do you define \"privilege\"?\n Articulate what privileges\n you think you have.",

    "Reminder Be open to changing\n your mind when\n receiving new\n information,\n especially if it makes\n you uncomfortable.",
]

export const level3 = [
    "How can you be a\n better listener to things\n you don't understand?",
    "What do you hope future\n generations understand about\n race? What is our role in helping\n them understand?",
    "How can you turn\n your privilege into positive\n change with your voice\n and resources?",
    "Wild Card Write down one lesson\n this conversation taught you.\n Both players. Compare."
]